import { useGetSubscriptionPricingQuery } from 'src/features/pricing/pricing.slice';
import { useActiveCampaign } from './use-active-campaign';

export function useYearlyPricing() {
  const priceQuery = useGetSubscriptionPricingQuery(false);
  const { campaign } = useActiveCampaign();

  const pricingData = priceQuery.data?.data;
  const yearlyPlan = pricingData?.yearlyPlan;
  const isStudent = pricingData?.isStudent ?? false;
  const studentDiscount = pricingData?.studentDiscount ?? 0;

  const symbol = yearlyPlan?.symbol ?? '$';
  const discount = campaign?.amount || (isStudent ? studentDiscount : 0);
  const yearlyPrice = yearlyPlan?.price ?? 0;
  const discountedYearlyPrice = (yearlyPrice * (100 - discount)) / 100;
  const isDiscounted = Boolean(discount);

  return { yearlyPrice, discountedYearlyPrice, symbol, isDiscounted, isLoading: priceQuery.isLoading };
}
